import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Login to your tapybl account',
  forgotPassword: 'forgot password?',
  submit: 'Sign in',
  dontHaveAccount: 'Don’t have an account? ',
  signup: 'Start your 7-day free trial',
  email: 'Email',
  password: 'Password',
  loginWithGoogle: 'Login with Google',
};

const welsh = {
  title: 'Mewngofnodwch i’ch cyfrif tapybl',
  forgotPassword: "Wedi anghofio'ch cyfrinair?",
  submit: 'Mewngofnodwch',
  dontHaveAccount: 'Nid oes gennych gyfrif?',
  signup: 'Cofrestrwch',
  email: 'e-bost',
  password: 'Cyfrinair',
  loginWithGoogle: 'Mewngofnodwch gyda Google',
};

export const loginTextES = {
  title: 'Login to your tapybl account',
  forgotPassword: 'forgot password?',
  submit: 'Sign in',
  dontHaveAccount: 'Don’t have an account? ',
  signup: 'Start your 7-day free trial',
  email: 'Email',
  password: 'Password',
  infoModalTitle: 'Interactive video learning.',
  infoModalText:
    'Make Learning Fun. Make it tapybl! Tapybl is an AI-powered video learning platform that transforms your existing content into engaging, sophisticated, interactive video lessons in a matter of minutes.',
};

export const loginText: any = getLocalizationBasedOnLang(english, welsh);
